import { Image } from "common/types/images";

import { getCdnImageDetails } from "seneca-common/utils/images";

import {
  ImageAssetParameters,
  MultiSelectContent,
  MultiSelectContentSource
} from "../types";

export function getModuleAssets(source: MultiSelectContent): Array<Image> {
  return source.image ? [source.image] : [];
}

export function transformModuleAssets(
  source: MultiSelectContentSource,
  assetParams: ImageAssetParameters
): MultiSelectContent {
  if (source.imageURL) {
    return {
      ...source,
      image: getCdnImageDetails(source.imageURL, assetParams.default)
    } as MultiSelectContent;
  }

  return source as MultiSelectContent;
}
